
export default {
  props: {
    label: {
      type: String,
      required: true
    },
    value: {
      type: [String, Array],
      default: null
    },
    required: {
      type: Boolean,
      default: false
    },
    showError: {
      type: Boolean,
      default: false
    },
    error: {
      type: String,
      default: ''
    },
    inputId: {
      type: String,
      required: true
    },
    options: {
      type: Array,
      default: () => []
    },
    multiple: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: 'Select options'
    }
  },
  data() {
    return {
      isOpen: false
    }
  },
  computed: {
    selectedOptions() {
      if (!this.value) return [];
      return this.multiple ? this.value : [this.value];
    },
    displayValue() {
      if (!this.selectedOptions.length) return this.placeholder;
      if (this.multiple) {
        return this.selectedOptions.map(opt => opt.name).join(', ');
      }
      return this.selectedOptions[0].name;
    }
  },
  methods: {
    toggleDropdown() {
      this.isOpen = !this.isOpen;
    },
    isSelected(option) {
      return this.selectedOptions.some(opt => opt.key === option.key);
    },
    toggleOption(option) {
      if (this.multiple) {
        const newValue = this.isSelected(option)
          ? this.selectedOptions.filter(opt => opt.key !== option.key)
          : [...this.selectedOptions, option];
        this.$emit('input', newValue);
      } else {
        this.$emit('input', option);
        this.isOpen = false;
      }
    },
    handleClickOutside(event) {
      if (!this.$el.contains(event.target)) {
        this.isOpen = false;
      }
    }
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  }
}
